import * as types from './mutation-types'
import controllerCommands from '../../services/controllerCommands'
import { createServiceCall } from '../actionsUtil'

export const storeControllerCommand = createServiceCall({
  mainAction: types.POST_CONTROLLER_COMMANDS_REQUEST,
  serviceFunction: controllerCommands.storeControllerCommand,
  successAction: types.POST_CONTROLLER_COMMANDS_SUCCESS,
  successDataPropery: '',
  failureAction: types.POST_CONTROLLER_COMMANDS_FAILURE
})
